var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"modal-style-page-layout",attrs:{"data-adjust-height":_vm.adjustHeight}},[_c('panel-frame',{staticClass:"modal-style-page-layout__panel"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }